<template lang="pug">
.drawer-navigation__item
  .wrapper.drawer-navigation__search
    v-text-field(
      :value="filters['search[name]']"
      dense
      height="41px"
      solo-inverted
      flat
      dark
      hide-details
      label="Поиск по названию"
      placeholder="Название мероприятия"
      @input="setFilter('search[name]', $event)"
    )
      template(v-slot:append): SearchIcon.grey--text

    v-btn.ml-1(icon color="primary" height="41px" width="41px" @click="$drawer.subdrawerToggle()")
      v-icon(
        color="#FAF0DD"
      ) {{ $drawer.subdrawer ?  'mdi-backburger' : 'mdi-format-list-bulleted' }}

  portal(to="subdrawer")
    .pa-5.search-drawer.v-theme--dark
      p.font-weight-black.mb-4 Поиск мероприятий

      v-text-field(
        :value="filters['search[name]']"
        dense
        filled
        label="Поиск по названию"
        @input="setFilter('search[name]', $event)"
      )

      ev-datetime-field(
        :value="filters['search[start_at]']"
        filled
        dense
        only-date
        toplabel
        label='Дата начала'
        @input="setFilter('search[start_at]', $event)"
      )

      ev-datetime-field(
        :value="filters['search[end_at]']"
        filled
        dense
        only-date
        toplabel
        label='Дата окончания'
        @input="setFilter('search[end_at]', $event)"
      )

      event-member-types(
        :value="filters['search[member_type]']"
        filled
        label="Тип участников"
        hide-details
        dense
        clearable
        @input="setFilter('search[member_type]', $event)"
      )

      v-expansion-panels(tile flat filled accordion)
        v-expansion-panel.transparent
          v-expansion-panel-header  Место проведения
          v-expansion-panel-content
            region-input(
              :value="filters.region && filters.region.id"
              dense
              filled
              label="Регион"
              return-obj
              clearable
               @input="setFilter('region', $event)"
            )
            directory-mun-input(
              v-if="filters.region"
              :value="filters.municipality && filters.municipality.id"
              :region="filters.region.id"
              filled
              dense
              label="Муниципалитет"
              @input="setFilter('municipality', $event)"
            )

        v-expansion-panel.transparent
          v-expansion-panel-header Мероприятие
          v-expansion-panel-content
            organization-input(
              :value="filters['search[organization_id]']"
              filled
              dense
              @input="setFilter('search[organization_id]', $event)"
            )
            event-level-input(
              :value="filters['search[level]']"
              dense
              filled
              clearable
              @input="setFilter('search[level]', $event)"
            )
            program-direction-input(
              :value="filters['search[directory_direction_id][]']"
              dense
              filled
              @input="setFilter('search[directory_direction_id][]', $event)"
            )
            event-type-input(
              :value="filters['search[event_type][]']"
              dense
              filled
              clearable
              @input="setFilter('search[event_type][]', $event)"
            )
        v-expansion-panel.transparent
          v-expansion-panel-header Группы мероприятий
          v-expansion-panel-content
            search-categories-field(
              :value="filters['search[category_id]']"
              @input="setFilter('search[category_id]', $event)"
            )
        .full-width
          v-checkbox(
            hide-details="auto"
            label="Платное участие"
            true-value="[2,3]"
            false-value="[1]"
            @change="setFilter('search[pay_type]', JSON.parse($event))"
          )
      v-btn.mt-4(
        v-if="hasChanges"
        block
        @click="reset"
      ) Сбросить
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import EventRequirementsInput from '@/components/inputs/EventRequirementsInput.vue';
import ProgramDirectionInput from '@/components/inputs/ProgramDirectionInput.vue';
import RegionInput from '@/components/inputs/RegionInput.vue';
import EventTypeInput from '@/components/inputs/EventTypeInput.vue';
import DirectoryMunInput from '@/components/inputs/DirectoryMunInput.vue';
import EventMemberTypes from '@/components/inputs/EventMemberTypes.vue';
import OrganizationInput from '@/components/inputs/OrganizationInput.vue';
import EventLevelInput from '@/components/inputs/EventLevelInput.vue';
import SearchCategoriesField from '@/components/inputs/SearchCategoriesField.vue';
import DatePicker from '../DatePicker.vue';

import SearchIcon from '../icons/SearchIcon.vue';

const DEBOUNCE_DELAY = 300;

export default {
  name: 'SearchDrawer',
  components: {
    SearchIcon,
    DatePicker,
    ProgramDirectionInput,
    RegionInput,
    EventRequirementsInput,
    EventTypeInput,
    DirectoryMunInput,
    EventMemberTypes,
    OrganizationInput,
    EventLevelInput,
    SearchCategoriesField,
  },
  computed: {
    ...mapGetters({
      filters: 'eventFilters/getFilters',
      hasChanges: 'eventFilters/hasChanges',
    }),
  },
  watch: {
    searchDrawer: {
      handler(val) {
        const subdrawerType = val ? this.$conf.DRAWER_TYPES.portal : null;
        this.$drawer.subdrawerSet(subdrawerType);
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener('keypress', this.pressEnter);
  },
  beforeDestroy() {
    window.removeEventListener('keypress', this.pressEnter);
  },
  methods: {
    ...mapActions({
      resetFilters: 'eventFilters/RESET_FILTERS',
    }),
    setFilter: _.debounce(function (key, value) {
      this.$store.dispatch('eventFilters/SET_FILTER', { key, value });
    }, DEBOUNCE_DELAY),
    reset() {
      this.resetFilters();
    },
  },
};
</script>

<style lang="scss">

  .drawer-navigation__search {
    display: flex;

    .v-input {
      height: 41px;
      background-color: #acaac1;
      color: #737373;
    }

    .v-btn {
      z-index: 2;
      border-radius: 5px;
      background-color: #{$infoGrey};
    }
  }

.search-drawer {
  color: #59636A;

  .title {
    font-size: 20px;
    line-height: 120%;
  }

  .v-text-field .v-input__slot {
    background: rgba(255, 255, 255, 0.4) !important;
  }

  .v-expansion-panel-header,
  .v-expansion-panel-header__icon i.v-icon.theme--light,
  .v-expansion-panel-content__wrap {
    color: #59636A !important;
    padding: 0;
  }

  .v-expansion-panel::before {
    box-shadow: none !important;
  }
}
</style>
